import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createPricePlanCalculator(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): PricePlanCalculatorInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.PricePlanCalculator,
      parentId,
      masterBlockId,
    ),
    popupId: null,
  }
}
